import React from 'react';
import AgentManagement from './AgentManagement';
import Search from './Search';
import Help from '../../../Common/Help';
import Settings from './Settings';
import Profile from '../../../Common/Profile';
import Notifications from '../../../Common/Notifications';
import InsightsChatGate from '../../../Common/InsightsChatGate';
import PermissionGates from 'components/PermissionGates';
import PERMISSIONS from '../../../../../../permissionDefinitions';
import FeatureGate, {
  FEATURE_GATES,
} from '../../../../../../components/FeatureGate';
import Row from '../../../../../../components/Common/Row';

const SETTINGS_PERMISSIONS = [
  PERMISSIONS.BILLING.VIEW_BILLING,
  PERMISSIONS.DATA_MANAGEMENT.INTEGRATIONS_CONFIG_VIEW,
  PERMISSIONS.DATA_MANAGEMENT.INTEGRATIONS_CONFIG_MODIFY,
  PERMISSIONS.USER_MANAGEMENT.VIEW_USER,
];

const Right = () => {
  return (
    <>
      <Search />
      <Row centerAlign spaceBetween style={{ margin: '0px 8px' }}>
        <FeatureGate featureName={FEATURE_GATES.AI_INSIGHTS_CHAT}>
          <InsightsChatGate />
        </FeatureGate>
        <Help />
        <AgentManagement />
        <PermissionGates.HasAny requiredPermissions={SETTINGS_PERMISSIONS}>
          <Settings />
        </PermissionGates.HasAny>
        <Notifications />
      </Row>
      <Profile />
    </>
  );
};

export default Right;
